import React from 'react';
import { motion } from 'framer-motion';

function About() {
  return (
    <div style={containerStyle}>
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} style={cardStyle}>
        <h1 style={titleStyle}>About ZenQB</h1>
        <div style={glowLineStyle} />
        <p style={textStyle}>ZenQB is an AI-powered platform designed to revolutionize how students and educators access, practice, and generate exam-ready question papers.</p>
        <p style={textStyle}>Whether you're in School (grades 1-10) or College, ZenQB supports all your exam preparation needs. From Kerala Board to ICSE, IGCSE, IB, and Engineering syllabi — we've got every curriculum covered.</p>
        <p style={textStyle}>Our intelligent system helps you create personalized practice material in seconds. From concept review to full mock tests — we've got you covered. Plus, our AI Chatbot is here to answer your doubts instantly, 24/7.</p>
        <div style={featureGridStyle}>
          {[
            { icon: '🏫', title: 'School & College', text: 'Full support for grades 1-10 and engineering courses' },
            { icon: '⚡', title: 'Instant Generation', text: 'Create custom question papers in seconds' },
            { icon: '🤖', title: 'AI Chatbot', text: 'Get instant answers to your study doubts' },
            { icon: '📚', title: 'Comprehensive', text: 'Coverage across all major curricula' },
          ].map((f, i) => (
            <div key={i} style={featureItemStyle}>
              <span style={featureIconStyle}>{f.icon}</span>
              <h3 style={featureTitleStyle}>{f.title}</h3>
              <p style={featureTextStyle}>{f.text}</p>
            </div>
          ))}
        </div>
        <div style={disclaimerStyle}>
          <p style={disclaimerTextStyle}><strong>⚠️ Disclaimer:</strong> AI-generated answers are for learning reference only. Always verify with official sources or consult your teachers for accuracy.</p>
        </div>
        <p style={footerStyle}>Crafted with ❤️ by the ZenQB Team</p>
      </motion.div>
    </div>
  );
}

const containerStyle = { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 20px', background: '#f8f9fc', fontFamily: "'Inter', 'Segoe UI', sans-serif" };
const cardStyle = { background: '#ffffff', borderRadius: '24px', padding: '60px 40px', maxWidth: '900px', width: '100%', border: '1px solid #e5e7eb', boxShadow: '0 4px 20px rgba(0,0,0,0.06)' };
const titleStyle = { fontSize: '3rem', fontWeight: '700', marginBottom: '8px', color: '#111827', textAlign: 'center', letterSpacing: '-0.02em', fontFamily: "'Space Grotesk', 'Sora', sans-serif" };
const glowLineStyle = { width: '80px', height: '4px', background: 'linear-gradient(90deg, #6366f1, #a855f7)', borderRadius: '2px', margin: '0 auto 40px' };
const textStyle = { fontSize: '1.15rem', lineHeight: '1.8', marginBottom: '28px', color: '#4b5563', textAlign: 'center', maxWidth: '700px', marginLeft: 'auto', marginRight: 'auto' };
const featureGridStyle = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '24px', margin: '40px 0' };
const featureItemStyle = { background: '#ffffff', borderRadius: '16px', padding: '28px 20px', textAlign: 'center', border: '1px solid #e5e7eb' };
const featureIconStyle = { fontSize: '2rem', display: 'block', marginBottom: '12px' };
const featureTitleStyle = { fontSize: '1.1rem', fontWeight: '600', color: '#111827', marginBottom: '8px' };
const featureTextStyle = { fontSize: '0.9rem', color: '#6b7280', lineHeight: '1.5' };
const disclaimerStyle = { background: '#fffbeb', border: '1px solid #fde68a', borderRadius: '12px', padding: '20px 24px', margin: '32px 0' };
const disclaimerTextStyle = { fontSize: '0.95rem', color: '#92400e', lineHeight: '1.6', margin: 0 };
const footerStyle = { fontSize: '1rem', color: '#9ca3af', textAlign: 'center', marginTop: '20px' };

export default About;
